module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/sign-in-02ffd5f9df0270056c021f25c0996fe4.svg";